ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
ConnectStore = require 'components/enhancers/connect_store'
Modal = require 'components/common/modal'
NMAQuestionActions = require 'actions/nma_question_actions'
NMAQuestionStore = require 'stores/nma_question_store'
QuestionsSelector = require 'components/common/questions_selector'
Spinner = require 'components/common/spinner'
{ useCoffeeCallback, useCoffeeMemo, useI18n } = require 'lib/react_utils'

storeConnector =
  NMAQuestionStore: (Store) ->
    currentQuestion: Store.getCurrentQuestion()
    isApplying: Store.isImportingInRegularQuestionsModal()
    isLoading: Store.isLoadingQuestionsInRegularQuestionsModal()
    isOpen: Store.isImportFromRegularQuestionsModalOpen()
    outcomes: Store.getOutcomes()
    questions: Store.getQuestionsInImportFromRegularQuestionsModal()
    questionGroups: Store.getQuestionGroupsInImportFromRegularQuestionsModal()
    selectedQuestionIds: Store.getSelectedQuestionIdsInImportFromRegularQuestionsModal()

NMAImportFromRegularQuestionsModal = ({
  currentQuestion,
  isApplying,
  isLoading,
  isOpen,
  outcomes,
  questions,
  questionGroups,
  selectedQuestionIds,
}) ->
  i18n = useI18n 'nma:import_from_regular_questions_modal'

  onImport = useCoffeeCallback [currentQuestion, outcomes, questions, selectedQuestionIds], ->
    selectedQuestions = questions
      .filter (question) -> selectedQuestionIds.includes question.get '_id'
      .toList()
      .toJS()
    NMAQuestionActions.importRegularQuestions currentQuestion, outcomes, selectedQuestions

  blockedQuestions = useCoffeeMemo [questions], ->
    questions
      .filter (question) -> question.get('type') is 'diagnostic'
      .keySeq()
      .toList()

  <Modal
    closeButton={not isApplying}
    isOpen={isOpen}
    onClose={NMAQuestionActions.closeImportFromRegularQuestionsModal}
    title={i18n 'title'}
  >
    <div className="nma-import-from-regular-questions-modal">
      {if isLoading
        <Spinner />
      else
        <React.Fragment>
          <div className="mb-20">
            {i18n 'description'}
          </div>
          {if questions.isEmpty()
            <div className="text-center mb-10">
              {i18n 'no_questions'}
            </div>
          else
            <QuestionsSelector
              blockedQuestions={blockedQuestions}
              blockedQuestionTooltip={i18n 'blocked_question_tooltip'}
              className="mb-10"
              questions={questions}
              questionGroups={questionGroups}
              selectedQuestions={selectedQuestionIds}
              updateSelected={
                NMAQuestionActions.updateSelectedQuestionIdsInImportFromRegularQuestionsModal
              }
              withNumbers
            />
          }
          <ApplyCancelButtons
            applyLabel={i18n '/actions.import'}
            isApplying={isApplying}
            isCancelEnabled={not isApplying}
            isSubmitEnabled={not selectedQuestionIds.isEmpty()}
            onApply={onImport}
            onCancel={NMAQuestionActions.closeImportFromRegularQuestionsModal}
          />
        </React.Fragment>
      }
    </div>
  </Modal>

NMAImportFromRegularQuestionsModal.propTypes =
  currentQuestion: PropTypes.instanceOf(Immutable.Map)
  isApplying: PropTypes.bool.isRequired
  isLoading: PropTypes.bool.isRequired
  isOpen: PropTypes.bool.isRequired
  outcomes: PropTypes.instanceOf(Immutable.Map).isRequired
  questions: PropTypes.instanceOf(Immutable.Map).isRequired
  questionGroups: PropTypes.instanceOf(Immutable.Map).isRequired
  selectedQuestionIds: PropTypes.instanceOf(Immutable.List).isRequired

module.exports = ConnectStore NMAImportFromRegularQuestionsModal, [NMAQuestionStore],
  storeConnector
